import { render, staticRenderFns } from "./alibaba.vue?vue&type=template&id=339bc9da&scoped=true&"
import script from "./alibaba.vue?vue&type=script&lang=js&"
export * from "./alibaba.vue?vue&type=script&lang=js&"
import style0 from "./alibaba.vue?vue&type=style&index=0&id=339bc9da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339bc9da",
  null
  
)

export default component.exports